// extracted by mini-css-extract-plugin
module.exports = {"appRoot":"app_appRoot__18Ffs","contentSection":"app_contentSection__3riWZ","footerSection":"app_footerSection__1NyCo"};